import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/backendApi.png";
import projImg2 from "../assets/img/youtubeclone.png";
import projImg3 from "../assets/img/db.png";
import projImg4 from "../assets/img/foodOrdering.png"
import colorSharp2 from "../assets/img/color-sharp2.png";
import projImg5 from "../assets/img/lambda.png"
import projImg6 from "../assets/img/pulumi.png"
import projImg7 from "../assets/img/fakenews.png"
import projImg8 from "../assets/img/expenseTracker.png"
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Car Management Rental System using Oracle ",
      description: "Design & Development",
      imgUrl: projImg3,
      link:"https://github.com/barathis98/DAMG6210-KBASH"
    },
    {
      title: "YouTube Clone",
      description: "Design & Development",
      imgUrl: projImg2,
      link:"https://github.com/barathis98/Youtube-Clone"
    },
    {
      title: "Cloud Native Backend API",
      description: "Design & Development",
      imgUrl: projImg1,
      link:"https://github.com/barathis98/webapp"
    },
    {
      title: "Food Ordering App",
      description: "Design & Development",
      imgUrl: projImg4,

    },
    {
      title: "Serverless - AWS LAMBDA",
      description: "Design & Development",
      imgUrl: projImg5,
      link:"https://github.com/barathis98/serverless"
    },
    {
      title: "Basic Infrastructure for AWS",
      description: "Design & Development",
      imgUrl: projImg6,
      link:"https://github.com/barathis98/iac-pulumi"
    },
    {
      title:"Fake News Detection",
      description:"Design & Development",
      imgUrl:projImg7,
      link:"https://github.com/barathis98/Fake-news-detection"
    },
    {
      title:"Expense Tracker",
      description:"Design & Development",
      imgUrl:projImg8,
      link:"https://github.com/barathis98/expense-tracker"
    }
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>These GitHub repositories serve as living examples of my proficiency in various technologies, methodologies, and problem-solving approaches. Dive into the code, explore the commits, and get a closer look at how I approach software development. If you have any questions or would like more insights, don't hesitate to reach out. The projects are more than just code – they're a reflection of my passion for creating meaningful and impactful solutions.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Hover over the images</Nav.Link>
                    </Nav.Item>
                    {/* <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item> */}
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="section">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
